import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFetchOris } from '../../CustomHooks/useFetchOris';
import { useStyles } from '../../Styles/styles';

const OriAutocomplete = ({ selectedOri, handleChange, onlineState }) => {
  const { oriList, orisLoading } = useFetchOris(onlineState);
  const classes = useStyles();

  return (
    <Autocomplete
      autoSelect
      multiple={false}
      value={oriList?.find(ori => ori?.id === selectedOri) || null}
      id="ticket-search-ori-autocomplete"
      options={oriList}
      getOptionLabel={(option) => {
        if (option.oriName && option.abbreviation) {
          return option?.oriName + " - " + option?.abbreviation
        } else if (option.oriName || option.abbreviation) {
          return option.oriName || option.abbreviation
        } else {
          return ""
        }
      }}
      loading={orisLoading} // Show loading state when fetching
      style={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="ORI"
          InputLabelProps={{ shrink: true }}
          InputProps={{ style: { borderRadius: '5px' }, ...params.InputProps }}
          data-testid="ori-autocomplete-textfield"
        />
      )}
      onChange={handleChange}
      className={classes.matchMargin}
      data-testid="ori-autocomplete"
    />
  );
};

export default OriAutocomplete;
